export enum BiotwinSharePrivilege {
  Read = 0,
  Write = 1,
}

export enum BiotwinShareStatus {
  Pending = 0,
  Accepted = 1,
  Rejected = 2,
}

export interface BiotwinShare {
  biotypeId: number;
  biotypeName: string;
  createdAt: string;
  id: number;
  email: string;
  message?: string;
  privilege: BiotwinSharePrivilege;
  ownerDisplayName: string;
  ownerId: number;
  ownerName: string;
  status: BiotwinShareStatus;
}
